import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

interface CreateOrderResponse {
  responseObj: {
    order: {
      id: string // The generated order ID, e.g., "JIORN1324A5726C6DA00"
      status: string
      // ... other fields from sample response
    }
    metaData: {
      redirectionUrl: string
      nextAction: string
      // ... other fields
    }
  }
}

const responseParser = (data: any): CreateOrderResponse => {
  
  if (isStatusOK(data) && data?.errorCode === 0) {
    const innerData = data?.data
    if (innerData?.responseStatus && innerData?.responseStatus?.code !== '000') {
      throw getNetworkResponseError(innerData || data);
      // throw getNetworkResponseError(innerData)
    }
    const responseObject = innerData?.responseObj
    if (responseObject && responseObject.order) {
      return responseObject as CreateOrderResponse
    } else {
      console.error('API SUCCESS, but order data is missing:', innerData)
      throw { code: -2, message: 'Invalid response structure from server.' }
    }
  } else {
    throw {
      code: data?.errorCode || -1,
      message: data?.message || 'Network request failed',
    }
  }
}

export const createOrderAPI = (tokens: any, requestBody: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers['x-jfsUserId'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || 'N/A'
  // config.headers['x-channel-user-id'] = RootStore.agent.agentInfo.agentUserLoginId || '1123766817865366323';
  config.headers['x-channel-user-id'] =
    RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || '1123766817865366323'
  config.headers['x-intercept-gateway'] = 'SERVICE/JPB'

  console.log('API Request Headers Check:', {
    'x-channel-id': config.headers['x-channel-id'] || '3155',
    'x-channel-user-id': config.headers['x-channel-user-id'],
    'x-intercept-gateway': config.headers['x-intercept-gateway'],
  })

  const request: Request<{}> = {
    apiPath: APIEndPoints.createOrderAPI,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, { status: 'INITIATED' })

  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Create Order API Raw Response')
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, { status: 'SUCCESS' })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, { status: 'FAILED', errorDescription: err })
      throw err
    })
}
